/*******************************************************************************
TOGGLE SIDE NAV SUB SECTION
Opens or closes a sub-section in the side nav.
*******************************************************************************/

// Opens the side navigation menu
export default function toggleSubSection(e) {
    const $subSection = $(e.currentTarget);
    const $subGroup = $subSection.parents('.side-nav__group');

    // Exit out here if the sub section is a link
    if ($subSection.is('a') || $subGroup.hasClass('is-search-result')) { return; }

    // Figure out if the section is currently open or closed
    const isOpen = $subGroup.hasClass('is-open');

    // Close all the other sub sections and then toggle the current sub section
    $('.side-nav__group').removeClass('is-open');
    if (isOpen) {
        $subGroup.removeClass('is-open');
    }
    else {
        $subGroup.addClass('is-open');
        $subGroup.find('.side-nav__item').first().get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}
